import { CommodityBase } from './base/commodity-base';

export class Commodity extends CommodityBase { }